function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "0,119.496 28.722,173.323 43.726,184.372 49.561,185.952 55.248,180.43 63.456,182.48  79.714,171.743 91.235,173.798 99.915,167.8 107.021,177.742 107.021,193.848 116.334,191.475 116.334,191.794 120.755,195.74  140.172,181.215 145.383,182.48 151.854,169.848 143.645,170.168 144.279,163.219 138.275,158.011 142.073,149.334 134.964,143.489  127.539,144.596 133.542,132.439 139.063,136.389 148.063,129.284 172.375,125.02 179.477,116.021 173.001,104.971 186.9,81.292  190.686,80.976 196.532,73.873 192.104,67.243 200,50.669 187.213,43.249 181.216,44.829 163.691,62.503 142.073,56.512  139.543,65.979 143.171,78.607 134.646,81.292 125.966,80.501 124.854,90.762 98.028,86.026 97.234,82.87 87.604,82.081  99.131,52.72 114.445,46.721 120.434,25.092 109.548,21.936 102.439,38.04 96.132,37.728 99.445,17.208 92.813,14.046  89.023,31.722 87.128,14.836 91.235,12.939 91.708,7.1 80.03,5.045 81.375,21.443 70.406,20.826 63.456,38.824 71.5,50.669  71.194,64.878 82.401,73.873 77.507,82.081 71.194,82.556 67.877,108.132 67.243,108.132 54.458,95.185 43.726,89.979  28.418,94.712 20.205,112.07 "
});

var Svg14 = function Svg14(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "JAL",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg14, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/14.9bb39021.svg";
export { ForwardRef as ReactComponent };